module.exports = __webpack_public_path__ + "static/media/reports_student_summary_report.78f19320.mov";